import React from 'react';
import PropTypes from 'prop-types';
import { BaasicHeaderTemplate } from 'themes/components';

function BaasicHeader(props) {
	return <BaasicHeaderTemplate {...props} />
}

BaasicHeader.propTypes = {
	rootStore: PropTypes.object,
	baasicTableSettingsViewStore: PropTypes.object,
	title: PropTypes.string,
	reloadFunc: PropTypes.func,
	disabledBtn: PropTypes.bool,
}

export default BaasicHeader;



// WEBPACK FOOTER //
// ./src/core/components/BaasicHeader.jsx